import React, { useState } from 'react';
import logComponent from '../../common/logComponent';
import './LargeNumberIcon.css';

export default function LargeNumberIcon({ number, text }) {
  const [key, setKey] = useState('val');
  if (logComponent('LargeNumberIcon')) { console.debug('LargeNumberIcon rendered'); }


    return (
      <div className="Large-Number-Icon">
        <p className="Large-Number-Icon__number">{ number != null ? number : '-' }</p>
        <p className="Large-Number-Icon__text">{ text }</p>
      </div>
    );
}